import { render, staticRenderFns } from "./MenuNavigationButton.vue?vue&type=template&id=155297c7"
import script from "./MenuNavigationButton.vue?vue&type=script&lang=js"
export * from "./MenuNavigationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports